import { render, staticRenderFns } from "./group-create.vue?vue&type=template&id=411961e2&scoped=true&"
import script from "./group-create.vue?vue&type=script&lang=js&"
export * from "./group-create.vue?vue&type=script&lang=js&"
import style0 from "./group-create.vue?vue&type=style&index=0&id=411961e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411961e2",
  null
  
)

export default component.exports